import React from 'react'
import Label from "components/general/Label"
import { ColumnBib, ColumnName, ColumnNoc } from "components/common/TableColumns"
import { ColumnIntermediateRank, ColumnIntermediateTime, ColumnIntermediateAvgSpeed } from "components/common/TableColumnsIntermediates"
import { filterArray, findArray } from 'helpers/utils'
import { ResultRankDiff } from 'components/presentation/ResultRank'
import SportCode from "components/common/SportCode"


function getCell(row, split) {
    let cell = null
    if (!!row) {
        let intermediate = findArray(row.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [split] })
        cell = <ResultRankDiff result={intermediate?.er_value} rank={intermediate.er_rank} diff={intermediate.er_diff} />
    }
    return cell
}

export function TableColumns(columnsAdded) {
    let numCols = findArray(columnsAdded, { code: ['INTERMEDIATES_NUM'], type: ['EC'] }).value
    let config = filterArray(columnsAdded, { code: ['INTERMEDIATE'] })
    config = config.filter((item) => item.pos !== 'S');
    let columnsExt = []



    //Columns Splits
    config.map((item) => {

        let type = findArray(item?.extension, { code: ['TYPE'] })?.value
        let valInter = (type === 'SL' || type === 'LAP1' || type === 'LAP2' || type === 'LAP3' || type === 'LAP4' || type === 'LAP5')
            ? <>  - <SportCode code={type} discipline='MTB' entity="@IntPtType" /> </>
            : ''

        let split = item.pos === 'F' ? numCols : item.pos;
        let header = item.pos === 'F'
            ? <Label data="HeaderFinish" />
            : <> {item.value}km {valInter}</>
        columnsExt.push(
            {
                Header: header,
                accessor: (props) => (
                    props?.extendedResults
                        ? findArray(props.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [item.pos] }).er_sortorder
                        : ''
                ),
                Cell: (props) => (
                    getCell(props.cell.row.original, item.pos)
                ),
                isVisible: false,
                disableSortBy: false,
                columnIndex: split,
                id: 'Splits-' + split,
                className: 'result',
                headerClassName: 'text-center w-10',
                sortType: "absoluteOrderNumber"
            },

        )
    })
    return (
        [
            ColumnIntermediateRank({}),
            ColumnBib({ label: "HeaderRaceNo" }),
            ColumnNoc({}),
            ColumnName({}),

            ...columnsExt,

            ColumnIntermediateAvgSpeed({ label: "HeaderAvgSpeedDesc" }),
        ]
    )
}




export function TableColumnsSM(columnsAdded) {
    let numCols = findArray(columnsAdded, { code: ['INTERMEDIATES_NUM'], type: ['EC'] }).value
    let config = filterArray(columnsAdded, { code: ['INTERMEDIATE'] })
    config = config.filter((item) => item.pos !== 'S');
    let columnsExt = []
    //Columns Splits
    config.map((item) => {
        let split = item.pos === 'F' ? numCols : item.pos;
        let header = item.pos === 'F' ? <Label data="HeaderFinish" /> : item.value + ' Km';
        columnsExt.push(

            {
                Header: header,
                accessor: (props) => (
                    props?.extendedResults
                        ? findArray(props.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [item.pos] }).er_value

                        : ''

                ),

                Cell: (props) => (
                    getCell(props.cell.row.original, item.pos)
                ),
                isVisible: false,
                disableSortBy: false,
                columnIndex: split,
                id: 'Splits-' + split,
                className: 'result',
                headerClassName: 'text-center w-10',
            },

        )
    })


    return (
        [
            ColumnIntermediateRank({}),
            ColumnBib({ label: "HeaderRaceNo" }),
            ColumnNoc({}),
            ColumnName({}),
            ...columnsExt,

        ]
    )
}
